import BarChartIcon from "@mui/icons-material/BarChart";
import { Menu } from "@mui/material";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import { CAMPAIGN_PERMISSIONS } from "@/constants/modules.permissions";
import ROUTE_URLS from "@/constants/route-urls";
import useLanguage from "@/contexts/language-context";
import useHasNoPermission from "@/hooks/use-check-permissions";
import { ICampaignStatistics } from "@/interfaces/campaign-statistics.interface";
import { StatisticsPageMessages } from "@/messages/campaigns/statistics/statistics-page.messages";
import NotificationItem from "@/mui/Items/NotificationItem";

interface Props {
  isOpen: boolean;
  anchorEl: (EventTarget & HTMLButtonElement) | null;
  onClose: () => void;
  messages: StatisticsPageMessages;
  selected: ICampaignStatistics;
}

export function CampaignPopover({ isOpen, anchorEl, onClose, messages, selected }: Props) {
  const router = useNavigate();
  const { campaignId } = useParams<{ campaignId: string }>();
  const { lang } = useLanguage();
  const hasNoPermissionToViewStats = useHasNoPermission(CAMPAIGN_PERMISSIONS.STATS);

  const handleViewStatsDetails = () => {
    if (!campaignId) return;
    router(ROUTE_URLS.campaignStatisticsDetails(lang, campaignId, selected.scheduleDate));
  };

  return (
    <Menu
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    >
      <NotificationItem
        disabled={hasNoPermissionToViewStats}
        icon={<BarChartIcon />}
        onClick={handleViewStatsDetails}
        title={messages.statsDetails}
      />
    </Menu>
  );
}
